import { workerManager } from '../../worker'
import type {
  StepExportOptions,
  StepExportRequest,
  StepExportResult,
  StepExportSource,
} from './types'

/**
 * 创建默认 STEP 导出选项。
 *
 * @param productName STEP 产品名称。
 * @returns 默认 STEP 导出选项。
 */
export function createDefaultStepExportOptions(productName: string): StepExportOptions {
  return {
    schema: 'AP242DIS',
    unit: 'MM',
    productName,
    writeAssembly: true,
    writeSurfaceCurves: false,
    writeColors: true,
    writeLayers: true,
    writeMaterials: true,
    writeValidationProps: true,
  }
}

/**
 * 规整导出文件基础名称。
 *
 * @param value 原始名称。
 * @returns 可用于下载的基础文件名称。
 */
export function normalizeStepExportFileBaseName(value: string): string {
  const normalized = value
    .trim()
    .replace(/[\\/:*?"<>|]/g, '_')
    .replace(/\s+/g, '_')

  return normalized.length > 0 ? normalized : 'model'
}

/**
 * 创建 STEP 导出请求。
 *
 * @param input 请求输入。
 * @returns STEP 导出请求。
 */
export function createStepExportRequest(input: {
  fileBaseName: string
  source: StepExportSource
  options?: Partial<StepExportOptions>
}): StepExportRequest {
  const fileBaseName = normalizeStepExportFileBaseName(input.fileBaseName)
  const defaultOptions = createDefaultStepExportOptions(fileBaseName)

  return {
    fileBaseName,
    source: input.source,
    options: {
      ...defaultOptions,
      ...input.options,
      productName: input.options?.productName ?? defaultOptions.productName,
    },
  }
}

/**
 * 导出标准 STEP 文件。
 *
 * @param request STEP 导出请求。
 * @returns STEP 文件结果。
 */
export async function exportStep(request: StepExportRequest): Promise<StepExportResult> {
  return workerManager.exportStep(request)
}
